/**
 * Invitation Service
 * 
 * Handles invitation-related API calls for password setting.
 * These are public endpoints (no authentication required).
 */

import api from './api';
import type { SetPasswordRequest, ApiResponse } from '@budgira/shared';

export interface TokenValidationResponse {
  valid: boolean;
  firstName?: string;
  lastName?: string;
  email?: string;
  ownerEmail?: string;
  error?: string;
}

export interface SetPasswordResponse {
  success: boolean;
  message: string;
}

export const invitationService = {
  /**
   * Validate an invitation token
   */
  async validateToken(token: string): Promise<ApiResponse<TokenValidationResponse>> {
    const response = await api.get<ApiResponse<TokenValidationResponse>>(
      `/invitation/validate/${token}`
    );
    return response.data;
  },

  /**
   * Set password for an invited user
   */
  async setPassword(data: SetPasswordRequest): Promise<ApiResponse<SetPasswordResponse>> {
    const response = await api.post<ApiResponse<SetPasswordResponse>>(
      '/invitation/set-password',
      data
    );
    return response.data;
  },
};

export default invitationService;
